exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selWidth[data-v-271d5054]{width:350px !important}", ""]);

// exports
